import { type ErrorCode } from './ErrorCode'

export class AppError extends Error {
  public readonly code: ErrorCode
  public readonly details?: Record<string, unknown>
  public readonly statusCode?: number
  public readonly traceId?: string
  public readonly validationErrors?: Record<string, string[]>

  constructor({
    message,
    code,
    details,
    statusCode,
    traceId,
    validationErrors
  }: {
    message: string
    code: ErrorCode
    details?: Record<string, unknown>
    statusCode?: number
    traceId?: string
    validationErrors?: Record<string, string[]>
  }) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.details = details
    this.statusCode = statusCode
    this.traceId = traceId
    this.validationErrors = validationErrors
  }
}
